import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';

import { FrontendModalService } from '@tablesready/frontend-modal';
import { AppIcon } from '@tablesready/frontend-icons';

@Component({
  selector: 'tablesready-add-edit-user',
  templateUrl: './type-password-modal.component.html',
})
export class TypePasswordModalComponent implements OnInit {
  icon = AppIcon;
  form: UntypedFormGroup;

  constructor(
    private readonly modalController: FrontendModalService,
    private readonly fb: UntypedFormBuilder,
  ) { }

  ngOnInit(): void {
    this.form = this.fb.group({
      password: ['', [Validators.required]],
    });
  }

  confirm(): void {
    void this.modalController.dismiss(this.form.value.password);
  }

  close(): void {
    void this.modalController.dismiss();
  }
}
